import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <FeaturesSection />
        <RankingSection />
        <TopicsSection />
        <AboutSection />
        <AppSection />
        <CarouselSection />
        <ContactSection />
        <CommentsSection />
        <MediaSection />
        <CardsSection />
        <FaqSection />
        <IndexSection />
      </main>
      <Footer />
    </div>
  );
}